export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL

export const endpoints = {
  auth: {
    token: () => '/v1/auth/token/',
    refresh: () => '/v1/auth/refresh/',
  },
  user: {
    preferences: (userId: number | string) => `/v1/user/users/${userId}/preferences/`,
    changePassword: () => '/v1/user/users/change-password/',
    notifications: () => '/v1/notification/notifications/',
  },
  delivery: {
    list: () => '/v1/delivery/deliveries/',
    detail: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/`,
    proofs: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/proofs/`,
    timeline: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/timeline/`,
    attempts: (deliveryId: string) => `/v1/delivery/deliveries/${deliveryId}/attempts/`,
  },
} as const
